import config from '../constants/config';

export default (side: number): number => {
  return side * config.cmpx;
};
